module.exports = __webpack_public_path__ + "static/media/registration-bg-tv.9492bf74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/registration-bg-tv.jpg
// module id = 2934
// module chunks = 0